import _ from 'lodash'
import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import CacheRoute, { CacheRouteProps } from 'react-router-cache-route'

/**
 * 构建一个带缓存功能的路由项配置
 */
export function buildCacheRoute(options: ICacheRoute) {
  return {
    path: options.path,
    customId: options.customId,
    route: (
      <CacheRoute
        key={_.uniqueId('route_')}
        exact={options.exact == null ? true : options.exact}
        path={options.path}
        when={options.when || 'back'}
        cacheKey={options.path}
        component={options.component}
      />
    )
  }
}

export interface ICacheRoute {
  path: string
  customId: string
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  /**
   * @default true
   */
  exact?: boolean
  /**
   * @default back
   */
  when?: 'forward' | 'back' | 'always' | ((props: CacheRouteProps) => boolean)
}